import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const token = localStorage.getItem("token");

export const getListPrice = createAsyncThunk(
  "listprice/getallLists",
  async (url, { rejectWithValue }) => {
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const listPriceSlice = createSlice({
  name: "listprice",
  initialState: {
    loading: false,
    ListData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getListPrice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getListPrice.fulfilled, (state, action) => {
        state.loading = false;
        state.ListData = action.payload;
      })
      .addCase(getListPrice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default listPriceSlice.reducer;
